const AnalyteGroup = {
  AMINO_ACIDS_AND_ACYLCARNITINES: "Amino Acids/Acylcarnitines",
  HEMOGLOBINS: "Hemoglobins",
  GALT_TGAL: "GALT-TGAL",
  TREC: "TREC",
  ALD: "ALD",
  LYSOSOMAL: "LYSOSOMAL",   
  IRT: "IRT",
  TSH_T4: "TSH/T4",
  CAH_17_OHP: "CAH/17-OHP",
  BIOTINIDASE: "BIOTINIDASE"
};

export default AnalyteGroup;